import { ThematicLine } from 'Components/lines/thematic-line/ThematicLine';
export default ThematicLine;
